import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";
import { useIntl } from "react-intl";

import styles from "./BioModal.module.scss";
import { messages } from "../CreativeProcess.messages";
import { useUi } from "@jelly/lesson";

type JuliusBioModalProps = Omit<React.ComponentProps<typeof CarouselModal>, "children">;
export const JuliusBioModal: React.FC<JuliusBioModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  let linkToPresent = "placeholder-link";
  try {
    const url = new URL(formatMessage(messages.bioJuliusLink));
    linkToPresent = url.host;
  } catch {
    // ...
  }

  return (
    <ui.Modal {...props} title={formatMessage(messages.bioJuliusTitle)}>
      <div className={styles.slide}>
        <div className={styles.content}>{formatMessage(messages.bioJuliusDescription)}</div>
        <div className={styles.link}>
          <ui.Button
            size="small"
            shape={"normal"}
            theme={"primary"}
            onClick={() => window.open(formatMessage(messages.bioJuliusLink))}
          >
            {linkToPresent}
          </ui.Button>
        </div>
      </div>
    </ui.Modal>
  );
};

//TODO: override scrollbars colors
